export default "type EditFolderForm @form {\n  \"Folder name\"\n  name: String!\n  \"Description\"\n  description: String\n}\n";